export const conversionViewKey = userId => `bloansbooks:conversion-view:${userId || 'anonymous'}`;
export function readConversionView(userId) {
  try { return window.localStorage.getItem(conversionViewKey(userId)) === 'cards' ? 'cards' : 'list'; }
  catch (_) { return 'list'; }
}
export function writeConversionView(userId, view) {
  try { window.localStorage.setItem(conversionViewKey(userId), view === 'cards' ? 'cards' : 'list'); }
  catch (_) { /* The selected view still works when browser storage is unavailable. */ }
}
